import { Collapse } from '@material-ui/core/'
import React, { useState } from 'react'
import ArrowSvg from '../../../../assets/images/arrow-right.svg'
import CheckSvg from '../../../../assets/images/check.svg'
import ClockSvg from '../../../../assets/images/clock-icon.svg'
import ClockWhite from '../../../../assets/images/clock-white.svg'
import CrossSvg from '../../../../assets/images/cross.svg'
import EyeClose from '../../../../assets/images/eye-close.svg'
import EyeSvg from '../../../../assets/images/eye-purple.svg'
import HouseSvg from '../../../../assets/images/house-icon.svg'
import PointSvg from '../../../../assets/images/point.svg'
import ProvidersService from '../../../services/ProviderServices'
import './CustomCard.scss'

const CustomCard = ({ onClick, dni, guide, oc, name, date, filterCuds }) => {
  const [showdetails, setShowDetails] = useState(false)
  const [cuds, setCuds] = useState([])

  const showCuds = async () => {
    if (!showdetails) {
      setShowDetails(true)
      if (cuds.length === 0) {
        const formattedCuds = await formatCuds(oc)
        console.log("----------->formattedCuds", formattedCuds)
        setCuds(formattedCuds)
      }
    } else {
      setShowDetails(false)
    }
  }

  const formatCuds = async oc => {
    const cuds = await ProvidersService.getCudsByOc(oc)
    const formattedCuds = filterCuds ? cuds.filter(cud => (cud.estado && cud.estado.toUpperCase() === 'RECEPCIONADO')) : cuds
    return formattedCuds.map(cud => {
      cud.id = cud.cudNumber
      cud.location = cud.placeName
      cud.status = (cud.searchStatus || cud.estado)
      return cud
    })
  }

  const renderCudStatus = c => {
    console.log("c!", c)
    switch (c.status) {
      case 'Entregado':
        return (
          <div className='customcard-delivered'>
            <img src={CheckSvg} alt='location' />
            <h2>Entregado</h2>
          </div>
        )
      case 'Pendiente':
        return (
          <div className='customcard-pending'>
            <img src={ClockWhite} alt='location' />
            <h2>Pendiente</h2>
          </div>
        )
      case 'Listo para retirar':
        return (
          <div className='customcard-pending'>
            <img src={ClockWhite} alt='location' />
            <h2>Pendiente</h2>
          </div>
        )
      case 'Sin Recepcionar':
        return (
          <div className='customcard-pending'>
            <img src={ClockWhite} alt='location' />
            <h2>Pendiente</h2>
          </div>
        )
      case 'Extorno':
        return (
          <div className='customcard-devolution'>
            <img src={CrossSvg} alt='location' />
            <h2>Extorno</h2>
          </div>
        )
      case 'Por retornar':
        return (
          <div className='customcard-devolution'>
            {/* <img src={CrossSvg} alt='location' /> */}
            <h2>Por retornar</h2>
          </div>
        )
      case 'Sin Motivo':
        return (
          <div className='customcard-devolution'>
            <img src={CrossSvg} alt='location' />
            <h2>Sin rec. NE</h2>
          </div>
        )
      case 'Devuelto':
        return (
          <div className='customcard-devolution'>
            <img src={CrossSvg} alt='location' />
            <h2>{c.status}</h2>
          </div>
        )
      case 'Anulado / Sin Recepcionar':
        return (
          <div className='customcard-devolution'>
            <img src={CrossSvg} alt='location' />
            <h2>Cancelado</h2>
          </div>
        )
      default:
        return (
          <div className='customcard-cudlocation'>
            <img src={HouseSvg} alt='location' />
            <h2>{c.location ? c.location.toLowerCase(): 'No Locker'}</h2>
          </div>
        )
    }
  }

  return (
    <div className={`customcard-container ${showdetails && 'showing'}`}>
      <div className='customcard-head'>
        <div className='customcard-left'>
          <div className='customcard-title'>
            <h2>DNI <span>{dni}</span></h2>
            {!onClick && (
              <div>
                {!showdetails ? <img src={ClockSvg} alt='ocultar' /> : <img src={ClockWhite} alt='mostrar' />}
                <h3 className={showdetails ? 'showing' : ''}>{date}</h3>
              </div>)}
          </div>
          <h4>{name}</h4>
          {/* <h2 className={showdetails && 'showing'}>Guía <span> {guide}</span></h2> */}
          <h2 className={showdetails ? 'showing' : null}>Pedido N° <span> {oc}</span></h2>
          <div className='customcard-showdetails' onClick={() => showCuds()}>
            {showdetails ? <img src={EyeClose} alt='ocultar' /> : <img src={EyeSvg} alt='mostrar' />}
            <span className={showdetails ? 'showing' : null}>{showdetails ? 'Ocultar detalles' : 'Ver detalles'}</span>
          </div>
        </div>
        {onClick && <div className='customcard-right' onClick={() => onClick()}>
          <img src={ArrowSvg} alt='ir' />
        </div>}
      </div>
      <Collapse in={showdetails} className='customcard-details' timeout={200}>
        <h2>PRODUCTOS ({cuds.length})</h2>
        <div className='customcard-cudscontainer'>
          {cuds.map(c => (
            c.originType === 'ripley'
              ? <div key={c.id}>
                <img src={PointSvg} alt='.' />
                <h2 className={c.status > 1 ? 'cud-disabled' : null}>{c.id}<span>x{c.quantity}</span></h2>
                {renderCudStatus(c)}
              </div>
              : <>
                <div key={c.id}>
                  <h2>Sub-pedido N° {c.suborder}</h2>
                  {renderCudStatus(c)}
                </div>
                {c.skus.map(sku => (
                  <>
                    <p key={sku}><img src={PointSvg} alt='.' /> SKU {sku.sku} <span>x{sku.quantity}</span></p>
                  </>
                ))}
              </>
          ))}
        </div>
      </Collapse>
    </div>
  )
}

export default CustomCard
